export class MissingBlockDataError extends Error {
  constructor(source?: string) {
    super(`${source ? source + ': ' : ''}"data" input is required but was not provided.`);
  }
}
